import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '@shared/modules';

// Thirdparty Imports
import { RebalancesService } from '@core/services/rebalance.service';
import { RebalancingModel } from '@core/models/rebalancing-model.model';
import { FirstStepComponent } from "./first-step/first-step.component";
import { SecondStepComponent } from "./second-step/second-step.component";
import { ThirdStepComponent } from './third-step/third-step.component';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';

@Component({
    selector: 'app-rebalancing-form',
    templateUrl: './rebalancing-form.component.html',
    styleUrls: ['./rebalancing-form.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MaterialModule, FirstStepComponent, SecondStepComponent, ThirdStepComponent],
})
export class RebalancingFormComponent implements OnInit, OnDestroy {
    private readonly rebalancingsServices = inject(RebalancesService);
    private readonly route = inject(ActivatedRoute);
    private readonly location = inject(Location)
    readonly #subscriptions = new Subscription();

    currentStep = signal<number>(-1);
    rebalancingId!: number;

    isFromZeeForm: boolean = false;
    isInternal = true;

    file = signal<File | null>(null);
    previewImage = signal<string | ArrayBuffer | null>('');
    rebalance: RebalancingModel | null = null;

    lastOdo: number | null = null;

    ngOnInit(): void {
        this.isInternal = this.location.path().includes('services-and-repairs');
        this.#subscriptions.add(
            this.route.paramMap.subscribe(params => {
                this.rebalancingId = parseInt(params.get('id')!);
            }),
        );
        this.getRebalancing();
    }

    ngOnDestroy(): void {
        this.#subscriptions.unsubscribe();
    }

    getRebalancing() {
        this.rebalancingsServices.getRebalancing(this.rebalancingId).subscribe(data => {
            this.rebalance = data;
            this.currentStep.set(this.rebalance.steps.length + 1);
        });
    }
}
